<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        {{caption}}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="20"
        :dark="dark"
        :pagination="pagination"
        :clickableRows=true
        v-on:row-clicked="onRowClicked"
      >
        <template #team_name_short="{item}">
          <td>
            <img width="24px" height="32px" :src="'img/team-kits/shirt_' + item.team_name_short + '-66.webp'" :alt="item.team_name" />
          </td>
        </template>
        <template #last_name="{item}">
          <TablePlayerItem :item="item" :displayLoanIcon="true" />
        </template>
        <template #club_name="{item}">
          <td>
            <span class="h6">{{item.club_name}}</span>
            <br />
            {{item.manager_name}}
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import TablePlayerItem from './TablePlayerItem.vue'

export default {
  name: 'Table',
  components: { TablePlayerItem },
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return [{key:'club_name', label:'Club'}, {key:'week_score', label:'Week'}, {key:'window_score', label:'Win'}, {key:'total_score', label:'Total'}]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    pagination: Boolean
  },
  methods: {
    onRowClicked(event) {
      this.$emit('row-clicked', event);
    }
  }
}
</script>